<template>
    <div class="installation-groups-page">
        <vrm-header>
            <template v-slot:header-controls>
                <div class="vrm-tasks">
                    <div class="vrm-tasks__task">
                        <vrm-toggle-button
                            v-model="search.active"
                            label-class="gtag-top-menu-item gtag-top-menu-item--search-groups"
                            icon-class="sg-vrm-icon_040_search-16px"
                        />
                    </div>
                    <div class="vrm-tasks__task visible-lg">
                        <button class="sg-btn sg-blue" @click.prevent="createGroupPopup">
                            {{
                                $t('groups.create_group', {
                                    i18nFallback: 'Create installation group',
                                })
                            }}
                        </button>
                    </div>
                </div>
            </template>
        </vrm-header>
        <vrm-title>
            <template v-slot:page-title>
                <h1 class="vrm-page-title">
                    <span>{{ $t('groups.groups', { i18nFallback: 'Installation groups' }) }}</span>
                </h1>
            </template>
            <template v-slot:header-panels>
                <vrm-header-search-panel
                    key="search"
                    v-model="search.query"
                    :open="search.active"
                />
            </template>
            <template v-slot:header-controls>
                <div class="vrm-tasks">
                    <div class="vrm-tasks__task">
                        <vrm-toggle-button
                            v-model="search.active"
                            label-class="gtag-top-menu-item gtag-top-menu-item--search-groups"
                            icon-class="sg-vrm-icon_040_search-16px"
                        />
                    </div>
                    <div class="vrm-tasks__task visible-lg">
                        <button class="sg-btn sg-blue" @click.prevent="createGroupPopup">
                            {{
                                $t('groups.create_group', {
                                    i18nFallback: 'Create installation group',
                                })
                            }}
                        </button>
                    </div>
                </div>
            </template>
        </vrm-title>
        <div class="container">
            <p>
                {{ $t('groups.group_explainer') }}
            </p>
            <div class="sg-btn__container sg-btn__container--align-right hidden-lg">
                <button class="sg-btn sg-blue" @click.prevent="createGroupPopup">
                    {{ $t('groups.create_group', { i18nFallback: 'Create installation group' }) }}
                </button>
            </div>
            <p v-if="loading" class="sg-color-blue">
                {{ $t('core.loading', { i18nFallback: 'Loading...' }) }}
            </p>
            <p v-else-if="!groups.length" class="sg-color-blue">
                {{
                    $t('groups.no_groups_create_hint', {
                        i18nFallback:
                            'You have not created any groups yet, first create a group to add installations to it.',
                    })
                }}
            </p>
            <vrm-scroll-fade v-else>
                <table class="vrm-table installation-groups-page__table">
                    <thead>
                        <tr>
                            <th>
                                {{ $t('groups.groups', { i18nFallback: 'Installation groups' }) }}
                            </th>
                            <th>
                                {{ $t('groups.installations', { i18nFallback: 'Installations' }) }}
                            </th>
                            <th>
                                {{ $t('groups.linked_users', { i18nFallback: 'Linked users' }) }}
                            </th>
                            <th>
                                {{ $t('groups.linked_teams', { i18nFallback: 'Linked teams' }) }}
                            </th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="group in groups"
                            :key="group.idSiteGroup"
                            class="vrm-table__action"
                            @click.prevent="viewGroup(group.idSiteGroup)"
                        >
                            <td>{{ group.name }}</td>
                            <td>{{ group.sites.length }}</td>
                            <td>{{ group.users.length }}</td>
                            <td>{{ group.userGroups.length }}</td>
                            <td class="vrm-table__actions">
                                <router-link
                                    :to="{
                                        name: 'base.installation-group',
                                        params: { id: group.idSiteGroup },
                                    }"
                                    class="vrm-table__icon--link"
                                >
                                    <i class="sg-vrm-icon_049_arrow-right-16px" />
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </vrm-scroll-fade>
        </div>
    </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularRoute, ngInject } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmHeader from '@/vue/components/layout/VrmHeader';
import VrmTitle from '@/vue/components/layout/VrmTitle';
import VrmHeaderSearchPanel from '@/vue/components/molecules/VrmHeaderSearchPanel';
import VrmScrollFade from '@/vue/components/shared/VrmScrollFade';
import InstallationGroupCreateModal from '@/vue/components/modals/InstallationGroupCreateModal';
import VrmToggleButton from '@/vue/components/shared/toggles/VrmToggleButton';

@Component({
    components: {
        VrmToggleButton,
        VrmHeader,
        VrmHeaderSearchPanel,
        VrmScrollFade,
        VrmTitle,
    },
})
@AngularRoute('base.installation-groups', '/groups', { slot: 'main' })
@AngularLocaleBundle('core')
@AngularLocaleBundle('nav')
@AngularLocaleBundle('groups')
export default class InstallationGroups extends Vue {
    /** @type InstallationGroupsService */
    @ngInject()
    InstallationGroupsService;
    @ngInject()
    VrmModalService;

    loading = false;
    search = {
        active: false,
        query: '',
    };

    get groups() {
        return this.$store.state.InstallationGroupsService.groups;
    }

    created() {
        this.InstallationGroupsService.loadInstallationGroups();
    }

    createGroupPopup() {
        this.VrmModalService.openVueModal(InstallationGroupCreateModal);
    }

    viewGroup(idSiteGroup) {
        this.$router.push({
            name: 'base.installation-group',
            params: {
                id: idSiteGroup,
            },
        });
    }
}
</script>
